module.exports = __webpack_public_path__ + "static/media/amazon.da986ab9.svg";